import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintedCartInput,
    PrintedCart,
    UpdatePrintedCartInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PrintedCartService {
    private amplifyClient = generateClient();

    constructor() {}

    async getPrintedCart(id: string): Promise<PrintedCart> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getPrintedCart,
                    variables: { id }
                })
            ).data.getPrintedCart;
            if (data) return data as PrintedCart;
        } catch (error) {
            console.error('Error finding PrintedCart:', error);
            return null;
        }
    }

    async listPrintedCarts(): Promise<PrintedCart[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintedCarts
                })
            ).data.listPrintedCarts.items;
            if (data) return data as PrintedCart[];
        } catch (error) {
            console.error('Error finding listPrintedCarts:', error);
            return null;
        }
    }

    async createPrintedCart(
        input: CreatePrintedCartInput
    ): Promise<PrintedCart> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintedCart,
                    variables: {
                        input
                    }
                })
            ).data.createPrintedCart;
            if (data) return data as PrintedCart;
        } catch (error) {
            console.error('Error creating PrintedCart:', error);
            return null;
        }
    }
    async updatePrintedCart(
        input: UpdatePrintedCartInput
    ): Promise<PrintedCart> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintedCart,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintedCart;
            if (data) return data as PrintedCart;
        } catch (error) {
            console.error('Error creating PrintedCart:', error);
            return null;
        }
    }
}
